export default __webpack_public_path__ + "static/gallery-art-painting-01cb67446737b9cbecfa70951a24c243.jpg";